
		<base-modal
			[title]="title"
			(onOk)="ok()"
		>
			<table class="table">
				<thead>
					<tr>
						<th>
							{{ 'Дата регистрации' | translate }}
						</th>

						<th>
							{{ 'Пользователь' | translate }}
						</th>
					</tr>
				</thead>
				
				<tbody>
					<tr *ngFor="let user of users" [id]="user._id">
						<td>
							{{ user.created | dateTimeFormat }}
						</td>

						<td>
							<gotosupport
								[queryParams]="{email: user.email, username: user.username}"
							>
								{{ user.email || user.username }}
							</gotosupport>
							
							<span
								class="badge badge-pill badge-secondary"
								*ngIf="currentUser._id === user._id"
							>
								Текущий пользотавель
							</span>
						</td>
					</tr>
				</tbody>
			</table>
			
			<div class="text-center mt-3">
				<button
					type="button"
					class="btn btn-danger"
					(click)="blockAllRereg()"
					[disabled]="isBlocking"
				>
					<i class="fa fa-ban" *ngIf="!isBlocking"></i>
					<i class="fa fa-spinner fa-spin" *ngIf="isBlocking"></i>
					{{ isBlocking ? 'Блокировка...' : 'Заблокировать все перереги' }}
				</button>
			</div>
		</base-modal>
	